import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Copyright from './components/Copyright';
import QuickStart from './components/QuickStart';
import Features from './components/Features';
import Faq from './components/Faq';
import About from './components/About';
import VideoCapture from './components/VideoCapture';
import './style/main.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/copyright" element={<Copyright />} />
                <Route path="/quick-start" element={<QuickStart />} />
                <Route path="/features" element={<Features />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/about" element={<About />} />
                <Route path="/video-capture" element={<VideoCapture />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
